export type AppTheme = 'blue' | 'green' | 'pink';

export type AppRuntimeConfig = {
  operator?: string | null;
  theme?: AppTheme;
  lobbyName?: string | null;
};

declare global {
  interface Window {
    __APP_CONFIG__?: AppRuntimeConfig;
  }
}

const THEMES: readonly AppTheme[] = ['blue', 'green', 'pink'];

export function readRuntimeConfig(): AppRuntimeConfig {
  if (typeof window === 'undefined') {
    return {};
  }

  return window.__APP_CONFIG__ ?? {};
}

export const runtimeConfig = readRuntimeConfig();

export function resolveTheme(value: unknown, fallback?: string): AppTheme {
  if (THEMES.includes(value as AppTheme)) {
    return value as AppTheme;
  }
  if (THEMES.includes(fallback as AppTheme)) {
    return fallback as AppTheme;
  }
  return 'pink';
}
